import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconClose = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      fill="none"
      viewBox="0 0 26 26"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8792 6.33304L19.667 5.12086L13 11.7879L6.33299 5.12087L5.12081 6.33305L11.7878 13.0001L5.12081 19.6671L6.33299 20.8792L13 14.2122L19.667 20.8792L20.8792 19.6671L14.2122 13.0001L20.8792 6.33304Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
